export const SENDER = "info@thewhiteprojectco.com";

// template key -> {label, body(fn), mode}
export const TEMPLATES = {
  request_quote: { label: "Request quote", mode: "ask",
    body: (f, s) => `Hello ${f}, Could you please provide us with a quote for ${s} for the above property? Architectural plans and survey are attached. Let us know if you require anything else. Kind regards, The White Project Co.` },
  go_ahead: { label: "Go ahead – start the work (no quote)", mode: "start",
    body: (f, s) => `Hello ${f}, Please proceed with the ${s} for the above property. Architectural plans and survey are attached. Could you please confirm the expected turnaround and send the invoice with the report? Kind regards, The White Project Co.` },
  accept_quote: { label: "Accept quote / proceed", mode: "start",
    body: (f, s) => `Hi ${f}, Thanks for the quote. Please proceed with the ${s} for the above. Let us know the expected turnaround. Kind regards.` },
  updated_plans: { label: "Send updated plans", mode: "other",
    body: (f, s) => `Hello ${f}, Please find the updated architectural plans attached for ${s}. Please amend your report/certificate accordingly. Kind regards.` },
  chase: { label: "Chase", mode: "other",
    body: (f, s) => `Hello ${f}, Following up on the ${s} for the above property. Could you please advise when we can expect it? Kind regards.` },
  invoice_paid: { label: "Invoice paid – send final", mode: "other",
    body: (f, s) => `Hi ${f}, Invoice paid – remittance attached. Please send through the final ${s} report/certificate. Kind regards.` },
};

export const firstName = (contacts, company) => {
  const c = (contacts || "").split(/[;,(]/)[0].trim();
  return (c || company || "there").split(/\s+/)[0];
};

export const subjectFor = (project, service) => {
  const addr = (project?.name || project?.address || "").toUpperCase();
  const svc = (service || "").toUpperCase();
  return addr ? `${addr} – ${svc}` : svc;
};

export const buildGmailUrl = ({ to, cc, subject, body }) =>
  `https://mail.google.com/mail/u/?authuser=${encodeURIComponent(SENDER)}&view=cm&fs=1&to=${encodeURIComponent(to)}&cc=${encodeURIComponent(cc || "")}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
